import { FR, GB, MD, NL, RO } from 'country-flag-icons/react/3x2'

const Flag = ({ locale }) => (
  <>
    {locale === 'en' && <GB />}
    {locale === 'fr' && <FR />}
    {locale === 'ro' && <RO />}
    {locale === 'md' && <MD />}
    {locale === 'nl' && <NL />}
  </>
)
export default Flag
